// extracted by mini-css-extract-plugin
export default {"wrap":"yG-z","fullWidth":"zG-z","hideOnDesktop":"AG-z","content":"BG-z","hasOpenedNav":"CG-z","crumbsList":"DG-z","dropdownsWrap":"EG-z"};